/** Class for application level configuration */
export class AppConfig {
  static evLiveSyncLogs = !!parseInt(
    process.env.REACT_APP_EV_LIVE_SYNC_LOGS ?? '0'
  );

  static evReduxLogs = !!parseInt(process.env.REACT_APP_EV_REDUX_LOGS ?? '0');
}
